import styled from '@emotion/styled';
import { ActionPromiseButton } from '../../Buttons/ActionButton/ActionPromiseButton';
import { Button } from '../../Buttons/Button/Button';
import { OL_COLOUR_KELP } from '../../Style/colours';

interface FlowModalButtonProps {
  primary?: boolean;
}

export const FlowModalButton = styled(Button)<FlowModalButtonProps>(
  ({ primary = false }) => ({
    'button.btn': {
      borderColor: OL_COLOUR_KELP,
      background: primary ? OL_COLOUR_KELP : '#ffffff',
      color: primary ? '#ffffff' : OL_COLOUR_KELP,
      fontSize: 14,
      borderRadius: 4,
      padding: '0.7em 1.5em',

      '&:hover': {
        background: primary ? OL_COLOUR_KELP : '#ffffff',
        color: primary ? '#ffffff' : OL_COLOUR_KELP,
      },
    },
  })
);

interface ActionPromiseButtonProps {
  primary?: boolean;
}

export const FlowModalActionButton = styled(
  ActionPromiseButton
)<ActionPromiseButtonProps>(({ primary = false }) => ({
  'button.btn': {
    borderColor: OL_COLOUR_KELP,
    background: primary ? OL_COLOUR_KELP : '#ffffff',
    color: primary ? '#ffffff' : OL_COLOUR_KELP,
    fontSize: 14,
    borderRadius: 4,
    padding: '0.7em 1.5em',

    '&:hover': {
      background: primary ? OL_COLOUR_KELP : '#ffffff',
      color: primary ? '#ffffff' : OL_COLOUR_KELP,
    },
  },
}));
